import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const ListIconItem = ({ fields }) => {
  const tag = fields.highlight?.value ? 'strong' : 'p';
  return (
    <li className="vds-icon-listing__item">
      <i className="fa-solid fa-circle-check fa-lg fa-fw vds-colour-success" />
      <Text tag={tag} field={fields.text} />
    </li>
  );
};

export default ListIconItem;
